import React, { Component } from 'react';
import { Container, Collapse, Button, CardDeck, Modal } from 'reactstrap';
import './projects.css';
import ProjectCard from './projectCard';

var Translate = require('react-translate-component')

class Projects extends Component {
    constructor() {
        super(...arguments);
        this.state = { 
            isOpen: false
        }
    }
  
    toggle = () => {
        this.setState({
            isOpen: !this.state.isOpen
        })
        onclick = "this.style.visibility='hidden';"
      }

    render() {
        return (
            <div className="projects">
                <p className="sectionTitle"><Translate content='zrealizowane_projekty' /></p>
                <hr className='sectionTitleLine' />
                <p className="sectionDesc"><Translate content='przedstawiamy_panstwu' /></p>
                <Container>
                    <CardDeck >
                        <ProjectCard 
                        cardIndex="0"
                        title='rozbudowa_budynku'
                            subtitle='zlecenodawca_cushman'
                            image="FnrNP"
                            description='prefabrykacja_i_instalacja_swietlikow'>
                        </ProjectCard>

                        <ProjectCard  cardIndex="1"
                        title='budynek_biurowy_focus'
                            subtitle='zlecenodawca_cushman'
                            image="Focus"
                            description='naprawa_i_konserwacja_slusarki_aluminiowej'>
                        </ProjectCard>
                    </CardDeck>
                    <CardDeck>
                        <ProjectCard  cardIndex="2" title='hotel_intercontinental'
                            subtitle='zleceniodawca_riskotes'
                            image="InterContinental"
                            description='przeglad_elewacji_oraz_wykonanie_projektu'>
                        </ProjectCard>

                        <ProjectCard  cardIndex="3" title="wieza_kontroli_lotow"
                            subtitle='zleceniodawca_pazp'
                            image="WKL"
                            description='wymiana_szyb_zespolonych'>
                        </ProjectCard>
                    </CardDeck>
                    <Collapse isOpen={!this.state.isOpen}><Button color="primary" onClick={this.toggle} className="seeMore"><Translate content='zobacz_wiecej' /></Button></Collapse>
                    <Collapse isOpen={this.state.isOpen}>

                        <CardDeck>
                            <ProjectCard  cardIndex="4" title='inwestor_indywidualny'
                                subtitle='inwestor_indywidualny'
                                image="II"
                                description='przeglad_elewacji_oraz_wykonanie_projektu_naprawy'>
                            </ProjectCard>

                            <ProjectCard  cardIndex="5" title='marszalkowska'
                                subtitle='zlecenodawca_cushman'
                                image="Marszalkowska"
                                description='serwis_i_naprawy_slusarki'>
                            </ProjectCard>
                        </CardDeck>
                        <CardDeck>
                            <ProjectCard  cardIndex="6" title='wieza_widokowa'
                                subtitle='zleceniodawca_eiffage'
                                image="WW"
                                description='naprawa_i_konserwacja_konstrukcji'>
                            </ProjectCard>

                            <ProjectCard  cardIndex="7" title="hurtownia_kosmetykow"
                                subtitle='zleceniodawca_'
                                image="hurtownia"
                                description='elewacja_z_plyt'>
                            </ProjectCard>
                        </CardDeck>
                    </Collapse>
                </Container>              
            </div>
        );
    }
};


export default Projects;